import { LanguageCode } from '@/i18n/languages';
import { CodeTitle, IdName } from '@/types/general';
import { TranslationSource } from '@/types/platform-data';
import { storageKeys } from '@/utils/constants';
import { Cookies } from '@/utils/cookies';

export function descriptionPreview(source: string | null | undefined, max = 90): string {
    if (!source) return '';
    return createEllipsis(source.replace(/\n/g, ' '), max);
}

export function createEllipsis(source: string | null | undefined, max = 50): string {
    if (!source) return '';

    const parts = source.split(' ');
    if (parts.length === 0) return '';

    const softLimit = max - 3;
    const firstPart = parts.shift()!;

    const result = [firstPart];
    let resultLen = firstPart.length;

    while (true) {
        const part = parts.shift();
        if (!part) break;
        resultLen += part.length;
        if (resultLen >= max) break;
        result.push(part);
        if (resultLen >= softLimit) break;
    }

    const ellipsis = parts.length > 0 ? '...' : '';
    return result.join(' ') + ellipsis;
}

export const filterJoin = (parts: Array<string | null | undefined>, sep = ', '): string =>
    parts.filter(Boolean).join(sep);

export function getGramCase(
    language: LanguageCode,
    gCase: 'nom' | 'gen' | 'loc',
    translations: TranslationSource[] | undefined,
    entity: IdName | CodeTitle | undefined,
): string {
    if (!entity) return '';
    const sources = (translations || []).filter((src) => src.language === language);
    if (sources.length > 0) {
        if (gCase === 'loc') {
            const source = sources.find((src) => !!src.loc);
            if (source) return source.loc!;
        }
        if (gCase === 'gen') {
            const source = sources.find((src) => !!src.gen);
            if (source) return source.gen!;
        }
        const source = sources.find((src) => !!src.nom);
        if (source) return source.nom!;
    }
    if (language === 'en') return ('name' in entity && entity.name) || ('title' in entity && entity.title) || '';
    return getGramCase('en', gCase, translations, entity);
}

export function getYoutubeLink(youtubeLink: string) {
    if (youtubeLink.includes('watch?v=')) {
        return youtubeLink.replace('watch?v=', 'embed/');
    }
    if (youtubeLink.includes('shorts/')) {
        return youtubeLink.replace('shorts/', 'embed/');
    }
    return youtubeLink;
}

//todo remove after audit
export const getRuCurrencyPrice = (languageCode: string, currency: string) =>
    languageCode === 'RU' && currency === 'RSD' ? 'РУБ' : currency;

export const createTestId = ({
    component,
    name,
    locale,
}: {
    component?: string;
    name?: string;
    locale?: string;
}): string => {
    const localeValue =
        (Cookies.get(storageKeys.prefLanguage) !== 'undefined' ? Cookies.get(storageKeys.prefLanguage) : locale) || '';
    if (!component) return `${localeValue}-${name}`;
    return `${component}-${localeValue}-${name}`;
};
